module.exports = __webpack_public_path__ + "media/images/icon/icons8-Find and Replace-7ec4740570cfc53b40d12cc93839cb2a.png";